import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const Menu = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;

  &.expanded {
    width: 215px;

    div[class*='MenuItemContainer'] {
      width: 100%;
      height: 30px;
      padding: 0;
    }

    div[class*='Item'] {
      width: 100%;
      height: 30px;
      justify-content: normal;
    }

    div[class*='Label'] {
      display: block;
      line-height: 2em;
    }
  }
`;

const MenuItemContainer = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 30px;
  margin-bottom: 3px;
  padding: 4px 0 4px 0;
`;

const Item = styled('div')`
  width: 100%;
  height: 30px;
  padding: 7px 6px 7.4px 6px;
  display: flex;
  align-items: center;
  position: relative;
  transition: var(--ph-background-transition);
  justify-content: center;

  & + & {
    margin-top: 19px;
  }

  &:hover:not(.active) {
    background-color: var(--dark-green);
  }

  &.active {
    background-color: var(--cyan-green);

    div[class*='Label'] {
      left: 29px;
    }
  }
`;

const Icon = styled(Svg)`
  width: 18px;
  height: 18px;
  fill: var(--white);

  & > svg {
    width: 18px;
    height: 18px;
  }

  &.active > svg {
    fill: var(--dark-blue);
  }
`;

const DashboardIcon = styled('div')`
  width: 18px;
  height: 18px;
  border-radius: var(--ph-border-radius-sm);
  border: solid 1px var(--white);
  margin: 2px 0;
  &.active {
    border-color: var(--dark-blue);
  }
`;

const Label = styled('div')`
  display: none;
  margin-left: 9.72px;
  font-family: var(--ph-font-family-lato-regular);
  font-size: var(--ph-text-xs);
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  color: var(--white);
  &:hover {
    font-weight: bold;
  }
  &.active {
    color: var(--dark-blue);
    font-weight: bold;
  }

`;

export default { Menu, Item, Icon, DashboardIcon, Label, MenuItemContainer };
